// import logo from '../../assets/images/logo.png';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { createRef, useState } from 'react';
import { useStateContext } from '../../context/ContextProvider';
import axiosClient from '../../axios-client';
// import login from '../../assets/images/logo.png'

import {
    InputGroup,
    InputRightElement,
    Spinner,
    useToast,
    Stack,
    Alert,
    AlertIcon,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';


import React from "react";
// Chakra imports
import {
    Box,
    Flex,
    Button,
    FormControl,
    FormLabel,
    Heading,
    Input,
    Link,
    Switch,
    Text,
    DarkMode,
    Checkbox,
} from "@chakra-ui/react";

import signInImage from "../../assets/images/signInImage.jpg";
import { useTranslation } from 'react-i18next';

export default function Login() {
    const { t } = useTranslation();

    const titleColor = "white";
    const textColor = "gray.400";
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [rememberMe, setRememberMe] = useState(false);
    const { setToken, isLoading, setIsLoading } = useStateContext()
    const [message, setMessage] = useState([])
    const toast = useToast()
    const navigate = useNavigate()

    React.useEffect(() => {
        const rememberedEmail = localStorage.getItem("REMEMBERED_EMAIL");
        const rememberedPassword = localStorage.getItem("REMEMBERED_PASSWORD");
        if (rememberedEmail) {
            setEmail(rememberedEmail);
            setRememberMe(true);
        }
        if (rememberedPassword) {
            try {
                setPassword(atob(rememberedPassword));
            } catch (e) {
                // Ignore if not a valid base64 string
            }
        }
    }, []);

    const onSubmit = ev => {
        toast.closeAll()
        ev.preventDefault()
        setIsLoading(true)
        const payload = {
            email,
            password,
        }

        if (rememberMe) {
            localStorage.setItem("REMEMBERED_EMAIL", email);
            localStorage.setItem("REMEMBERED_PASSWORD", btoa(password));
        } else {
            localStorage.removeItem("REMEMBERED_EMAIL");
            localStorage.removeItem("REMEMBERED_PASSWORD");
        }

        axiosClient.post('token/user/', payload)
            .then(({ data }) => {
                setToken(data.access, data.refresh); // Store both tokens
                setIsLoading(false);
                localStorage.setItem("role", data.role)
            })
            .catch((err) => {
                const response = err.response;
                setMessage({ alert: t(response.data.message), target: "" })
                setIsLoading(false)
            })

    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (isFormFilled && !isLoading) {
                onSubmit(e);
            }
        }
    };

    const [showPassword, setShowPassword] = useState(false);
    const isFormFilled = email && password;

    return (
        <Flex position='relative' backgroundSize={'cover'} bgImage={signInImage} h={'100vh'} overflow="hidden">
            {/* Dark overlay for better contrast */}
            <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bg="blackAlpha.400"
                zIndex={0}
            />
            <Flex
                flexDirection={'row'} h={'100vh'} w={'100%'} position="relative" zIndex={1}>
                <Box
                    display={{ base: "none", lg: "flex" }}
                    flexDirection='column'
                    justifyContent='center'
                    alignItems='center'
                    px={6}
                    h={'100%'} w={{lg:"40%",xl:"50%"}}
                    className="animate-fade-up"
                >
                    <Text
                        mb={3}
                        textAlign='center'
                        color='whiteAlpha.700'
                        letterSpacing='6px'
                        fontSize={{lg:'sm',xl:"md"}}
                        fontWeight='500'
                        textTransform="uppercase"
                    >
                        {t("BIENVENU DANS ECOLINKE")}
                    </Text>
                    <Text
                        textAlign='center'
                        color='transparent'
                        letterSpacing='8px'
                        fontSize={{lg:'2xl',xl:"4xl"}}
                        fontWeight='800'
                        bgClip='text !important'
                        bg='linear-gradient(135deg, #FFFFFF 0%, #B794F4 50%, #9F7AEA 100%)'
                        lineHeight="1.2"
                    >
                        ECOLINKE
                    </Text>
                    <Box
                        mt={4}
                        h="2px"
                        w="60px"
                        bg="linear-gradient(90deg, transparent, rgba(159, 122, 234, 0.6), transparent)"
                        borderRadius="full"
                    />
                </Box>
                <Flex h={'100%'} w={{ base: "100%",lg:"60%", xl: '50%' }} alignItems={'center'} justifyContent={'center'}>
                <Flex
                    w={{ base: "92%", sm: "85%", md:'55%', lg: '85%', xl: '70%' }}
                    backdropFilter='blur(20px) saturate(180%)'
                    WebkitBackdropFilter='blur(20px) saturate(180%)'
                    padding={{ base: 8, md: 10 }}
                    direction='column'
                    mr={{ base: 0, xl: 20 }}
                    rounded={"20px"}
                    background='rgba(20, 15, 40, 0.75)'
                    border="1px solid"
                    borderColor="whiteAlpha.100"
                    boxShadow="0 25px 60px -12px rgba(0,0,0,0.4), 0 0 40px -8px rgba(128, 90, 213, 0.1)"
                    className="animate-scale-in"
                >
                    <form onSubmit={onSubmit} onKeyDown={handleKeyDown} style={{ zIndex: 999 }}>
                        <Heading
                            color={titleColor}
                            fontSize={{ base: '26px', md: '30px' }}
                            mb='8px'
                            fontWeight="800"
                            letterSpacing="-0.02em"
                        >
                            {t("Login")}
                        </Heading>
                        <Text
                            mb='32px'
                            color={textColor}
                            fontWeight='400'
                            fontSize='14px'
                            lineHeight="1.6"
                        >
                            {t("Entrez votre adresse e-mail et votre mot de passe pour se connecter")}
                        </Text>
                        {message.alert &&
                            <Alert
                                status='error'
                                rounded="12px"
                                mb={4}
                                bg="rgba(254, 178, 178, 0.12)"
                                border="1px solid"
                                borderColor="rgba(254, 178, 178, 0.2)"
                            >
                                <AlertIcon />
                                <Text fontSize="13px" color="red.200">{message.alert}</Text>
                            </Alert>
                        }
                        <FormControl mb="5" id="email" isRequired >
                            <FormLabel color="whiteAlpha.700" fontSize="13px" fontWeight="600" letterSpacing="0.02em">{t("Adresse email")}</FormLabel>
                            <Input
                                autoComplete="one-time-code"
                                color={titleColor}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="text"
                                placeholder={t('Tapez votre adresse email')}
                                h="48px"
                                bg="whiteAlpha.50"
                                border="1px solid"
                                borderColor="whiteAlpha.200"
                                borderRadius="12px"
                                fontSize="14px"
                                _hover={{ borderColor: "whiteAlpha.300" }}
                                _focus={{
                                    borderColor: "purple.400",
                                    boxShadow: "0 0 0 3px rgba(128, 90, 213, 0.2)",
                                    bg: "whiteAlpha.100"
                                }}
                                _placeholder={{ color: "whiteAlpha.400", fontSize: "14px" }}
                                transition="all 0.2s ease"
                            />
                        </FormControl>
                        <FormControl id="password" isRequired isInvalid={message.target === "password"}>
                            <FormLabel mb="2" color="whiteAlpha.700" fontSize="13px" fontWeight="600" letterSpacing="0.02em">{t("Mot de passe")}</FormLabel>
                            <InputGroup mb="4">
                                <Input
                                    autoComplete="new-password"
                                    color={titleColor}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder={t('Tapez votre mot de passe')}
                                    h="48px"
                                    bg="whiteAlpha.50"
                                    border="1px solid"
                                    borderColor="whiteAlpha.200"
                                    borderRadius="12px"
                                    fontSize="14px"
                                    _hover={{ borderColor: "whiteAlpha.300" }}
                                    _focus={{
                                        borderColor: "purple.400",
                                        boxShadow: "0 0 0 3px rgba(128, 90, 213, 0.2)",
                                        bg: "whiteAlpha.100"
                                    }}
                                    _placeholder={{ color: "whiteAlpha.400", fontSize: "14px" }}
                                    transition="all 0.2s ease"
                                />
                                <InputRightElement h={'full'}>
                                    <Button
                                        color="whiteAlpha.600"
                                        variant={'ghost'}
                                        _hover={{ color: "white", bg: "whiteAlpha.100" }}
                                        borderRadius="lg"
                                        onClick={() =>
                                            setShowPassword((showPassword) => !showPassword)
                                        }>
                                        {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                                    </Button>
                                </InputRightElement>
                            </InputGroup>
                        </FormControl>


                        <Stack spacing={6}>
                            <Stack
                                direction={{ base: 'column', sm: 'row' }}
                                align={'start'}
                                justify={'space-between'}>
                                <Checkbox
                                    isChecked={rememberMe}
                                    onChange={(e) => setRememberMe(e.target.checked)}
                                    colorScheme="purple"
                                    color="purple.300"
                                    size="sm"
                                >
                                    <Text fontSize="13px" color="whiteAlpha.700">{t("Se souvenir de moi")}</Text>
                                </Checkbox>
                                <Link
                                    href='/reset_password'
                                    color={'purple.300'}
                                    fontSize="13px"
                                    fontWeight="500"
                                    _hover={{ color: "purple.200", textDecoration: "none" }}
                                    transition="color 0.15s ease"
                                >
                                    {t('Mot de passe oublié ?')}
                                </Link>
                            </Stack>
                            <Button
                                fontSize='14px'
                                fontWeight="600"
                                h="48px"
                                type="submit"
                                colorScheme='purple'
                                onClick={onSubmit}
                                isLoading={isLoading}
                                isDisabled={!isFormFilled}
                                borderRadius="12px"
                                bg="linear-gradient(135deg, #7B5EA7 0%, #9F7AEA 100%)"
                                _hover={{
                                    bg: "linear-gradient(135deg, #6B4E97 0%, #8F6ADA 100%)",
                                    transform: "translateY(-1px)",
                                    boxShadow: "0 8px 25px -5px rgba(128, 90, 213, 0.4)"
                                }}
                                _active={{ transform: "scale(0.98)" }}
                                transition="all 0.2s ease"
                                letterSpacing="-0.01em"
                            >
                                {isLoading ? <Spinner size="sm" /> : t("Connexion")}
                            </Button>
                        </Stack>

                        <Flex gap={2} mt={5} justify="center">
                            <Text color="whiteAlpha.500" fontSize="13px">{t("Vous n'avez pas de compte ?")}</Text>
                            <Text
                                color='purple.300'
                                fontWeight="600"
                                fontSize="13px"
                                cursor='pointer'
                                _hover={{ color: "purple.200" }}
                                transition="color 0.15s ease"
                                onClick={() => navigate('/register')}
                            >
                                {t("S'inscrire")}
                            </Text>
                        </Flex>

                    </form>

                </Flex>

                </Flex>
            </Flex>


        </Flex>
    );
}

